import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";

const initialValues = {
  username:"",
  password:"",
  confirmPassword:""
}
  
const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [values, setValues] = useState(initialValues);
  const [progressBar, setProgressBar] = useState(false);

  const history = useHistory();

  const handleInputChange = (e) => {

    const {name, value} = e.target;

    setValues({
      ...values,
      [name]: value
    });
  }

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => {

    const reqData = {
      username: formData.username,
      password: formData.password
    }

    if(validateInput(formData)){
      setProgressBar(true);
      axios.post(`${config.endpoint}/auth/register`,reqData)
      .then((response) => {
        // console.log(response);
        enqueueSnackbar("Registered Successfully", {variant:`success`});
        setProgressBar(false);
        history.push("/login", { from: "Register"})
      })
      .catch((err) => {
        if(err.response){
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(err.response.data);
          // console.log(err.response.status);
          // console.log(err.response.headers);
          enqueueSnackbar(err.response.data.message, {variant: `error`});
          setProgressBar(false);
        }
        else if(err.request){
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and return valid JSON", {variant: `error`});
          setProgressBar(false);
        }
        else{
          console.log("Error! - ", err.message);
          setProgressBar(false);
        }
      });
    }
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {

    if(data.username.length === 0){
      enqueueSnackbar("Username is a required field", {
        variant: `warning`,
      });
    }
    else if(data.username.length < 6)
    {
      enqueueSnackbar("Username must be at least 6 characters", {
        variant: `warning`,
      });
    }
    else if(data.password.length < 1){
      enqueueSnackbar("Password is a required field", {
        variant: `warning`,
      });
    }
    else if(data.password.length < 6){
      enqueueSnackbar("Password must be at least 6 characters", {
        variant: `warning`,
      });
    }
    else if(data.password !== data.confirmPassword){
      enqueueSnackbar("Passwords do not match", {
        variant: `warning`,
      });
    }
    else{
      return true;
    }

    return false;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            onChange={handleInputChange}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            onChange={handleInputChange}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            onChange={handleInputChange}
          />
          {progressBar? (<Box sx={{display:'flex', justifyContent:'center'}}> <CircularProgress disableShrink/></Box>):(<Button onClick={() => register(values)} className="button" variant="contained">
            Register Now
           </Button>)
          }
          <p className="secondary-action">
            Already have an account?{" "}
             <Link to="/login" className="link">
              Login here
             </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
